import React, { useEffect } from 'react';
import './Location.css'; // Link to the CSS file
import dest1 from "../../img/bhuleshwar.avif";
import dest2 from "../../img/MIT.jpg";
import dest3 from "../../img/nane-ghat.jpg";
import dest4 from "../../img/shaniwar-wada.jpg";
import dest5 from "../../img/aurangabad.jpg";
import dest6 from "../../img/destination-6.jpg";
import dest7 from "../../img/destination-7.jpg";

const Location = () => {
    const locations = [
        { name: 'Bhuleshwar', image: dest1 },
        { name: 'MIT', image: dest2 },
        { name: 'Nane Ghat', image: dest3 },
        { name: 'Shaniwar Wada', image: dest4 },
        { name: 'Aurangabad Heritage', image: dest5 },
        { name: 'Romania', image: dest6 },
        { name: 'India', image: dest7 },
        { name: 'Belgium', image: dest2 },
    ];

    useEffect(() => {
        const handleScroll = () => {
            const cards = document.querySelectorAll('.location-card');
            cards.forEach(card => {
                const rect = card.getBoundingClientRect();
                if (rect.top < window.innerHeight - 100) {
                    card.classList.add('visible');
                }
            });
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="location-container">
            <h1 className="heading">Popular Locations</h1>
            <p className="subheading">Connecting Needs with Offers for the Professional Flight Services. Book your next flight appointment with ease.</p>
            <div className="locations">
                {locations.map((location, index) => (
                    <div
                        key={index}
                        className={`location-card ${
                            index >= 3 && index <= 4 ? 'span-2' : ''
                        }`}
                    >
                        <img src={location.image} alt={location.name} className="location-image" />
                        <div className="location-name">{location.name}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Location;
